import { render, staticRenderFns } from "./Action_question.vue?vue&type=template&id=19ff57d8&scoped=true&"
import script from "./Action_question.vue?vue&type=script&lang=js&"
export * from "./Action_question.vue?vue&type=script&lang=js&"
import style0 from "./Action_question.vue?vue&type=style&index=0&id=19ff57d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ff57d8",
  null
  
)

export default component.exports